export const steps = [
  {
    element: '.navbar-intro',
    intro:
      '<h5>Menu Lateral</h5><p>Aqui estão disponíveis de maneira organizada, todas as funcionalidades do portal.</p>',
    tooltipClass: 'tol-intro-navbar',
    highlightClass: 'elm-intro-navbar',
  },
  {
    element: 'header div',
    intro:
      "<h5>Dados cadastrais</h5><p>Aqui são exibidas suas Informações Cadastrais. No <span class='mdi mdi-bell'></span>, constam as notificações dos serviços que você utilizou no portal.</p>",
    tooltipClass: 'tol-intro-usermenu',
    highlightClass: 'elm-intro-usermenu',
  },
  {
    element: '.intro-boletos',
    intro:
      '<h5>Lista com os Boletos</h5><p>Aqui são exibidos todos os seus boletos independentes do status, com opções de ordenações e mudança no formato de visualização. Você pode baixar, imprimir ou enviar por e-mail.</p>',
    tooltipClass: 'tol-intro-boletos',
    highlightClass: 'elm-intro-boletos',
  },
];

export const stepsMobile = [
  {
    element: '.bm-burger-button',
    intro:
      '<h5>Menu lateral</h5><p>Aqui estão disponíveis de maneira organizada, todas as funcionalidades do portal.</p>',
    tooltipClass: 'tol-intro-burger',
    highlightClass: 'elm-intro-burger',
  },
  {
    element: 'header div',
    intro:
      "<h5>Dados cadastrais</h5><p>Aqui são exibidas suas Informações Cadastrais. No <span class='mdi mdi-bell'></span>, constam as notificações dos serviços que você utilizou no portal.</p>",
  },
  {
    element: '.intro-boletos',
    intro:
      '<h5>Lista com os Boletos</h5><p>Aqui são exibidos todos os seus boletos independentes do status, com opções de ordenações e mudança no formato de visualização. Você pode baixar, imprimir ou enviar por e-mail.</p>',
  },
];
